<a class="link-color flex flex-row justify-start items-center" particleAnalytics analyticsCategory="link-cell-viewer"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText">
  <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis">
    <div *ngIf="item.cells[fieldDefinition.key]?.displayText"
         class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis" (click)="openTask()">
      {{item.cells[fieldDefinition.key]?.displayText}}
    </div>

    <div *ngIf="!item.cells[fieldDefinition.key]?.displayText"
         class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
      <button mat-button [matMenuTriggerFor]="actionMenu" class="orbitax-flat-button">
        <div class="flex flex-row justify-center items-center">
          <span class="username mr-12">Attach To Task</span>
          <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container">
        <button [disabled]="disabled" mat-menu-item class="" (click)="attachToNewTask()">
          <i class="fa-light fa-square-plus m-r-8"></i>
          <span>Attach To New Task</span>
        </button>
        <button [disabled]="disabled" mat-menu-item class="" (click)="attachToExistingTask()">
          <i class="fa-light fa-paperclip m-r-8"></i>
          <span>Attach To Existing Task</span>
        </button>
      </mat-menu>
    </div>
  </div>
</a>
